<template>
    <div class="block-market-page">
        <div class="page-header">
            <h1>{{ $t("chatbotv2.blockMarket") || "Block Market" }}</h1>
            <a-button type="primary" @click="navigateToCreateBlock" icon="plus" size="large">
                {{ $t("chatbotv2.createNewBlock") || "Create New Block" }}
            </a-button>
        </div>

        <a-tabs v-model="activeTab" class="market-tabs">
            <a-tab-pane key="marketplace" :tab="$t('chatbotv2.marketplace') || 'Marketplace'">
                <BlockMarketplace @view-details="viewBlockDetails" />
            </a-tab-pane>

            <a-tab-pane key="my-blocks" :tab="$t('chatbotv2.myBlocks') || 'My Blocks'">
                <MyBlocks @edit-block="editBlock" @view-details="viewBlockDetails" />
            </a-tab-pane>

            <a-tab-pane key="imported" :tab="$t('chatbotv2.importedBlocks') || 'Imported Blocks'">
                <ImportedBlocks @view-details="viewBlockDetails" />
            </a-tab-pane>

            <a-tab-pane v-if="isAdminSite" key="pending" :tab="$t('chatbotv2.pendingApproval') || 'Pending Approval'">
                <PendingApproval @view-details="viewBlockDetails" />
            </a-tab-pane>
        </a-tabs>

        <!-- Block Details Modal -->
        <BlockDetailsModal
            v-if="showDetailsModal"
            :block-id="selectedBlockId"
            @close="closeDetailsModal"
            @import="handleImport"
        />
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import BlockMarketplace from "./BlockMarketplace.vue";
import MyBlocks from "./MyBlocks.vue";
import ImportedBlocks from "./ImportedBlocks.vue";
import PendingApproval from "./PendingApproval.vue";
import BlockDetailsModal from "./BlockDetailsModal.vue";

export default {
    name: "BlockMarket",
    components: {
        BlockMarketplace,
        MyBlocks,
        ImportedBlocks,
        PendingApproval,
        BlockDetailsModal,
    },
    data() {
        return {
            activeTab: "marketplace",
            showDetailsModal: false,
            selectedBlockId: null,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
        isAdminSite() {
            return this.site?._id === "5d14ee322d95ad001ebdf213";
        },
    },
    methods: {
        ...mapActions({
            listAvailableBlocks: "customBlocks/listAvailableBlocks",
            listMyBlocks: "customBlocks/listMyBlocks",
            listImportedBlocks: "customBlocks/listImportedBlocks",
        }),
        navigateToCreateBlock() {
            this.$router.push("/chatbot/block-market/editor/new");
        },
        editBlock(blockId) {
            this.$router.push(`/chatbot/block-market/editor/${blockId}`);
        },
        viewBlockDetails(blockId) {
            this.selectedBlockId = blockId;
            this.showDetailsModal = true;
        },
        closeDetailsModal() {
            this.showDetailsModal = false;
            this.selectedBlockId = null;
        },
        handleImport() {
            this.closeDetailsModal();
            this.listAvailableBlocks();
            this.listImportedBlocks();
        },
    },
    created() {
        // Load initial data
        this.listAvailableBlocks();
        this.listMyBlocks();
        this.listImportedBlocks();
    },
    activated() {
        // Refresh data when navigating back to this page
        this.listAvailableBlocks();
        this.listMyBlocks();
        this.listImportedBlocks();
    },
};
</script>

<style lang="scss" scoped>
.block-market-page {
    padding: 20px;

    .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        h1 {
            margin: 0;
            font-size: 24px;
            font-weight: 600;
        }
    }

    .market-tabs {
        background: #fff;
        padding: 16px;
        border-radius: 8px;
    }
}
</style>

